import isNil from 'lodash/isNil'
import every from 'lodash/every'
import {type NonEmptyArray} from '@freckle/non-empty'
import {type IdentityProviderT} from '@frontrow/console/src/entities/helpers/identity-provider'

import {
  type RenaissanceSchoolClientT,
  type DetailedSchoolT
} from '@frontrow/console/src/models/school'

export function canBulkEdit(schoolData: NonEmptyArray<DetailedSchoolT>): boolean {
  const firstSchoolData = schoolData[0]
  const {renaissanceSchoolClient: firstSchoolRenaissanceClient} = firstSchoolData
  return every(schoolData, school => {
    return (
      hasSameRenaissanceClientFields(
        firstSchoolRenaissanceClient,
        school.renaissanceSchoolClient
      ) && bothOrNoneHaveRenaissanceAsActiveIdp(firstSchoolData.activeIdp, school.activeIdp)
    )
  })
}

function hasSameRenaissanceClientFields(
  client1?: RenaissanceSchoolClientT | null,
  client2?: RenaissanceSchoolClientT | null
): boolean {
  if (isNil(client1) && isNil(client2)) {
    return true
  }

  return (
    !isNil(client1) &&
    !isNil(client2) &&
    client2.platform === client1.platform &&
    client2.clientId === client1.clientId &&
    client2.rpid === client1.rpid &&
    client2.baseUrl === client1.baseUrl &&
    client2.starStatus === client1.starStatus
  )
}

function bothOrNoneHaveRenaissanceAsActiveIdp(
  activeIdp1?: IdentityProviderT | null,
  activeIdp2?: IdentityProviderT | null
): boolean {
  return (
    (activeIdp1 === 'renaissance' && activeIdp2 === 'renaissance') ||
    (activeIdp1 !== 'renaissance' && activeIdp2 !== 'renaissance')
  )
}
